module.exports = __webpack_public_path__ + "media/base/builder_big-b6d8aefb.svg";